export default __webpack_public_path__ + "assets/3d259da8efc33e68e96b370b4459c0aa.png";